<script>
  // ── Eine Buchung im Ganzen — und der Weg zurück (A7/L7, Plan 17.7) ────────
  //
  // ⚠ DIESES BAUTEIL HAT KEINE KIT-VORLAGE.
  // `zutat-detail.html` zeigt eine stornierte Buchung als ERGEBNIS
  // (durchgestrichen, „rückgängig gemacht am 28.08."), aber nirgends, WIE man
  // sie zurücknimmt — kein Knopf, kein Menü, keine Geste, weder mobil noch auf
  // dem Schreibtisch (Plan 17.3). Der Betreiber hat am 2026-09-09 entschieden:
  // Die Zeile öffnet ein Sheet, und die Rücknahme steht darin.
  //
  // Der Grund gegen einen leisen Knopf je Zeile: Auf 390 px nähme er dem
  // 44-px-Ziel der Zeile den Platz weg, und ein Fehlgriff wäre sofort eine
  // Gegenbuchung. Das Sheet ist ein Zwischenschritt, den man nicht versehentlich
  // macht — und zugleich der Ort, an dem später mehr Platz hat, ohne die Zeile
  // zu belasten.
  //
  // DREI ZUSTÄNDE, UND NUR EINER TRÄGT EINEN KNOPF
  //   1. Eingang, Inventur, Korrektur  → zurücknehmbar. Das ist alles, was von
  //      Hand entstanden ist, und nur dort entstehen Vertipper.
  //   2. EINZELNER Abgang aus einem Backtag → Hinweis statt Knopf. Ein Backtag
  //      erzeugt ein Dutzend Buchungen; einzeln zurückgenommen stünde ein
  //      Bestand da, der nicht mehr zu dem passt, was der Backtag verbraucht
  //      hat, und `lagerHatAbgangFuer()` hielte ihn weiter für gebucht — genau
  //      der halb zurückgenommene Zustand, den `lagerStornierenViele()` beim
  //      Buchen ausdrücklich verhindert.
  //   3. bereits zurückgenommen        → sagt, wann. Zweimal stornieren machte
  //      aus einer Rücknahme eine Buchung (lager-journal.js verhindert es).
  //
  // DAS GANZE BÜNDEL IST DIE VIERTE FASSUNG — UND SIE HAT WIEDER EINEN KNOPF
  // Der Hinweis unter 2. sagt seit L7 wörtlich: „Zurückgenommen wird er dort —
  // im Backtag, nicht bei der einzelnen Zutat." Genau dieser Ort ist die
  // Bewegungsliste der Bestandsansicht, wo ein Backtag als EINE Zeile steht.
  // Wird das Sheet von dort geöffnet, trägt `buchung.buchungIds` alle Zeilen
  // des Vorgangs, und zurückgenommen wird in EINER Transaktion
  // (`lagerStornierenViele`) — dieselbe Rücknahme, die der Meldung beim
  // Abschluss beiliegt, nur nicht mehr nur für die Sekunden, die ein Toast
  // steht. 2. bleibt unverändert: Aus dem Zutat-Detail gibt es sie weiterhin
  // nicht, dort ist die Zeile ja wirklich nur eine von zwölf.
  /**
   * @type {{ buchung: any, onschliessen: () => void, onzurueckgenommen: () => void }}
   */
  let { buchung, onschliessen, onzurueckgenommen } = $props();

  const t = (k, p) => window.t(k, p);

  let laeuft = $state(false);

  /** Gesetzt, wenn das Sheet einen ganzen Backtag meint statt einer Buchung. */
  let buendel = $derived(Array.isArray(buchung?.buchungIds) ? buchung.buchungIds : null);
  let ausBacktag = $derived(!buendel && !!buchung?.quelle_backtag_id && buchung?.art === 'abgang');
  let ruecknehmbar = $derived(
    !!buchung && !buchung.storniert && !ausBacktag && (!buendel || buendel.length > 0));

  /** Vorzeichenbehaftet — ein Eingang ist ein Zuwachs, und das soll man sehen. */
  function delta(gramm) {
    const m = window.lagerMenge(Math.abs(gramm));
    return `${gramm < 0 ? '−' : '+'}${m.wert} ${m.einheit}`;
  }

  function menge(gramm) {
    const m = window.lagerMenge(gramm);
    return `${m.wert} ${m.einheit}`;
  }

  function datum(ts) {
    return new Date(ts).toLocaleDateString(window.currentLocale(),
      { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  async function zuruecknehmen() {
    if (laeuft || !ruecknehmbar) return;
    laeuft = true;
    const ok = buendel
      ? await window.lagerStornierenViele(buendel)
      : await window.lagerStornieren(buchung.id);
    laeuft = false;
    if (!ok) {
      // lager-journal.js schreibt den Grund in die Konsole — der Nutzer sieht
      // sie nicht, und ein Knopf, der nichts sagt, sieht aus wie einer, der
      // nichts tut.
      window.notify?.({ level: 'err', text: t('lager_sheet_fehler') });
      return;
    }
    window.notify?.({ level: 'ok', text: t(buendel ? 'lager_sheet_backtag_zurueck' : 'lager_sheet_zurueckgenommen') });
    onzurueckgenommen();
  }
</script>

<svelte:window onkeydown={(e) => { if (e.key === 'Escape') onschliessen(); }} />

<div class="lg-host">
  <div class="lg-scrim" onclick={onschliessen} role="presentation"></div>

  <div class="lg-sheet" role="dialog" aria-modal="true" aria-label={t('lager_sheet_titel')}>
    <div class="lg-sheet__head">
      <div class="lg-sheet__kopftext">
        <div class="lg-sheet__titel">{buchung?.titel}</div>
        <!-- Aus der Bewegungsliste heraus benennt der Titel die ART („Eingang");
             welche Zutat gemeint ist, stünde sonst nirgends im Sheet. -->
        {#if buchung?.untertitel}
          <div class="lg-sheet__unter">{buchung.untertitel}</div>
        {/if}
      </div>
      <button type="button" class="lg-sheet__x" onclick={onschliessen}
              aria-label={t('lager_sheet_schliessen')}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"
             stroke-linecap="round" width="19" height="19" aria-hidden="true">
          <line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>
        </svg>
      </button>
    </div>

    <dl class="lg-sheet__daten">
      <div class="lg-sheet__paar">
        <dt>{t('lager_sheet_betrag')}</dt>
        <dd class="lg-sheet__betrag" class:is-ein={(buchung?.menge ?? 0) >= 0}>
          {delta(buchung?.menge ?? 0)}
        </dd>
      </div>
      <div class="lg-sheet__paar">
        <dt>{t('lager_sheet_datum')}</dt>
        <dd>{datum(buchung?.ts)}</dd>
      </div>
      <!-- `quelle` und nicht `meta`: Die Zeile im Journal laesst den Beleg bei
           einer zurueckgenommenen Buchung weg (Platz auf 390 px, Plan 17.15).
           Hier ist Platz, und hier gehoert er hin. -->
      {#if buchung?.quelle}
        <div class="lg-sheet__paar">
          <dt>{t('lager_sheet_herkunft')}</dt>
          <dd>{buchung.quelle}</dd>
        </div>
      {/if}
      <!-- Eine stornierte Zeile hat keinen Stand: Ihr Betrag ist am Ende nicht
           eingetreten (Plan 17.4). Das Feld entfällt dann ganz, statt einen
           Strich zu zeigen. -->
      {#if buchung?.standDanach != null}
        <div class="lg-sheet__paar">
          <dt>{t('lager_sheet_stand')}</dt>
          <dd>{menge(buchung.standDanach)}</dd>
        </div>
      {/if}
    </dl>

    <div class="lg-sheet__fuss">
      {#if buchung?.storniert}
        <p class="lg-sheet__hinweis">
          {t('lager_sheet_storniert', { datum: new Date(buchung.zurueckgenommenAm)
            .toLocaleDateString(window.currentLocale(), { day: '2-digit', month: '2-digit', year: 'numeric' }) })}
        </p>
      {:else if ausBacktag}
        <p class="lg-sheet__hinweis">{t('lager_sheet_abgang_hinweis')}</p>
      {:else}
        <button type="button" class="lg-sheet__weg" onclick={zuruecknehmen} disabled={laeuft}>
          {t(buendel ? 'lager_sheet_backtag_zuruecknehmen' : 'lager_sheet_zuruecknehmen')}
        </button>
      {/if}
    </div>
  </div>
</div>

<style>
  /* Dieselbe Hülle wie die Eingangsmaske: schmal eine Fläche am unteren Rand,
     ab 600 px ein Dialog über der Ansicht. Ein zweites Overlay-Muster im
     selben Modul wäre eine zweite Sache zum Verstehen. */
  .lg-host { position: fixed; inset: 0; z-index: 60; display: flex; container-type: inline-size; }
  .lg-scrim { position: absolute; inset: 0; background: rgba(41, 37, 36, 0.30); }

  /* Schmal klebt das Sheet unten — dort ist der Daumen, und dort ist es
     hergekommen. */
  .lg-sheet {
    position: relative;
    margin-top: auto;
    width: 100%;
    background: var(--lg-card);
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -12px 40px -18px rgba(28, 25, 23, 0.45);
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

  .lg-sheet__head {
    display: grid; grid-template-columns: 1fr 44px; align-items: center;
    gap: 8px; padding: 14px 10px 10px 20px;
    border-bottom: 1px solid var(--lg-line-fein);
  }
  .lg-sheet__kopftext { min-width: 0; }
  .lg-sheet__titel {
    font-size: 16px; font-weight: 700; color: var(--lg-ink); letter-spacing: -0.015em;
  }
  .lg-sheet__unter {
    margin-top: 2px;
    font-size: 12px; color: var(--lg-ink-mute);
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  }
  .lg-sheet__x {
    width: 44px; height: 44px; display: flex; align-items: center; justify-content: center;
    border: 0; border-radius: 10px; background: none; color: var(--lg-ink-soft); cursor: pointer;
  }
  .lg-sheet__x:hover { background: rgba(41, 37, 36, 0.06); color: var(--lg-ink); }
  .lg-sheet__x:focus-visible { outline: 2px solid var(--lg-ink); outline-offset: -2px; }

  .lg-sheet__daten { margin: 0; padding: 6px 20px 14px; }
  .lg-sheet__paar {
    display: flex; align-items: baseline; justify-content: space-between; gap: 16px;
    padding: 9px 0;
  }
  .lg-sheet__paar + .lg-sheet__paar { border-top: 1px solid var(--lg-line-fein); }
  .lg-sheet__paar dt { font-size: 12px; color: var(--lg-ink-mute); flex-shrink: 0; }
  .lg-sheet__paar dd {
    margin: 0; text-align: right; min-width: 0;
    font-size: 13.5px; color: var(--lg-ink); font-variant-numeric: tabular-nums;
  }
  .lg-sheet__betrag { font-weight: 700; font-size: 15px; }
  .lg-sheet__betrag.is-ein { color: var(--lg-ein-ink); }

  .lg-sheet__fuss { padding: 4px 20px 20px; }
  .lg-sheet__hinweis {
    margin: 0; padding: 12px 14px;
    background: var(--lg-tint); border: 1px solid var(--lg-line); border-radius: 10px;
    font-size: 12px; line-height: 1.5; color: var(--lg-ink-soft);
  }
  /* Kein Terrakotta: Zurücknehmen ist nicht die Handlung, zu der dieser Ort
     einlädt — es ist die, die man braucht, wenn etwas schiefging. */
  .lg-sheet__weg {
    width: 100%; min-height: 48px; padding: 0 18px;
    border: 1px solid var(--lg-fehlt-edge); border-radius: 10px;
    background: var(--lg-fehlt-bg); color: var(--lg-fehlt-ink);
    font: inherit; font-size: 14.5px; font-weight: 700; cursor: pointer;
  }
  .lg-sheet__weg:hover { background: #ffe4e6; }
  .lg-sheet__weg:focus-visible { outline: 2px solid var(--lg-fehlt-ink); outline-offset: 2px; }
  .lg-sheet__weg:disabled { opacity: 0.6; cursor: default; }

  @container (min-width: 600px) {
    .lg-sheet {
      margin: auto;
      width: 420px;
      border-radius: 14px;
      border: 1px solid var(--lg-line);
      box-shadow: 0 24px 48px -24px rgba(28, 25, 23, 0.45);
    }
  }
</style>
